export var MODAL_ROOT_PATH = '/modal';
